import React, { useContext, useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import { setLanguage } from '../../../actions/appActions';
import { cleanLanguageCode } from '../../../helpers/language';
import { WelletContext } from '../../../context/WelletContext';
import Header from '../../../components/Common/Header/Header';
import ContentApp from '../../../components/ContentApp';
import NotificationSwitch from '../../../components/Notifications/NotificationSwitch/NotificationSwitch';
import GeneralSelectorPicker from '../../../components/SelectorPicker/GeneralSelectorPicker';
import { skeletonNotificationConfiguration } from '../../../components/Skeletons/SkeletonNotifications';
import styles from './configuration.module.css';

const Configuration = () => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const welletContext = useContext(WelletContext);

  const associate = useSelector((state) => state.associates);
  const language = useSelector((state) => state.app.language);

  const [loading, setLoading] = useState(true);
  const [userNotifications, setUserNotifications] = useState(null);
  const isDoorman = associate.user?.roles?.includes('doorman');

  const languages = [
    { value: 'en', label: t('languages.english') },
    { value: 'es', label: t('languages.spanish') },
  ];

  const selectedLanguage = languages.find(
    (option) => option.value === cleanLanguageCode(language)
  );

  const getNotificationName = (notificationType) => {
    switch (notificationType) {
      case 'RESERV_PENDING':
        return t('notificationsType.pending');
      case 'RESERV_REJECTED':
        return t('notificationsType.rejected');
      case 'RESERV_CANCELLED':
        return t('notificationsType.cancelled');
      case 'RESERV_NO_SHOW':
        return t('notificationsType.NoShow');
      case 'RESERV_PAYMENT_ACCREDITED':
        return t('notificationsType.paymentAccredited');
      case 'RESERV_CONFIRMED':
        return t('notificationsType.confirmed');
      case 'RESERV_WAITING_PAYMENT':
        return t('notificationsType.reservWaitingPayment');
        default:
          break;
    }
  };

  const fetchUserNotifications = async () => {
    setLoading(true);
    try {
      const result = await welletContext.apis.tickets.get('/api/Notification/GetUserNotificationType');
      setUserNotifications(result.data);
    } catch (error) {
      console.error(error);
    } finally {
      setLoading(false);
    }
  };

  const handleChangeLanguage = async (language) => {
    dispatch(setLanguage(language.value));
    try {
      await welletContext.apis.tickets.post('/associates/saveconfig', { lang: language.value });
    } catch (error) {
      console.error(error);
    }
  };

  useEffect(() => {
    if (!userNotifications) {
      fetchUserNotifications();
    }
  }, [userNotifications]);

  return (
    <div style={{ overscrollBehaviorY: 'none' }}>
      <Header title={<div className='bold'>{t('settings')}</div>} />
      <ContentApp>
        {loading ? (
          <div className='mt-3'>{skeletonNotificationConfiguration()}</div>
        ) : (
          <>
            {!isDoorman && (
              <>
                <div className='bold mt-3 font-normal' style={{ color: 'var(--color-font-primary)' }}>
                  {t('notificationsType.notificationsByreservationStatus')}
                </div>
                <div className={`${styles.container} mt-3 fade-up`}>
                  {userNotifications?.map((n, i) => (
                    <NotificationSwitch
                      key={i}
                      name={getNotificationName(n.notificationType)}
                      isActive={n.isActive}
                      type={n.notificationType}
                    />
                  ))}
                </div>
              </>
            )}

            <div className='bold mt-3 mb-3 font-normal' style={{ color: 'var(--color-font-primary)' }}>
              {t('languages.title')}
            </div>
            <GeneralSelectorPicker
              options={languages}
              selectedValue={selectedLanguage.value}
              onChange={handleChangeLanguage}
              placeholder={selectedLanguage?.label}
             
            />
          </>
        )}
      </ContentApp>
    </div>
  );
};

export default Configuration;
